import React from 'react';
import '../pages/Contact.css';

export const ContactForm = () => {
  return (
    <div className="contact-form">
      <h1 className="form-title">Contact Form</h1>
      <form action="https://formsubmit.co/susana.garcia.dev@gmail.com" method="POST">   
      <input className="form-input" type="text" placeholder="Name" name="name"/>
      <input className="form-input" type="email" placeholder="Email" name="email" />
      <textarea className="form-textarea" placeholder="Enter your message here..." rows="6"></textarea>
      <button    className="send" >send</button> </form>
    </div>
  );
};

